import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { take } from 'rxjs/operators';
import { BillingService } from '../../../lib/services/billingService';

@Component({
  selector: 'mj-invoices',
  templateUrl: './invoices.component.html',
  styleUrls: ['./invoices.component.scss'],
})
export class InvoicesComponent implements OnInit {
  invoices;

  constructor(
    private billingService: BillingService,
    private ref: ChangeDetectorRef
  ) {}

  ngOnInit() {
    const unit_id = localStorage.getItem('unit_id');
    this.billingService
      .fetchInvoices(unit_id)
      .pipe(take(1))
      .subscribe(invoices => {
        this.invoices = invoices.data;

        this.ref.detectChanges();
      });
  }
}
